<ion-content>
  <ion-grid [fixed]="false">
    <ion-row>
      <!-- Elements -->
      <ion-col *ngFor="let item of products; let i = index" sizeXs="12" sizeMd="6">
        <app-i-item [item]="item"></app-i-item>
      </ion-col>
      <ion-col size="12" *ngIf="!isLoading === true && !products[0]">
        <app-i-no-results></app-i-no-results>
      </ion-col>
      <!-- Skeleton loading -->
      <ion-col size="12" *ngIf="isLoading === true">
        <app-i-skeleton></app-i-skeleton>
      </ion-col>
    </ion-row>
  </ion-grid>
  <!-- Infinite scroll (get next elements) -->
  <ion-infinite-scroll threshold="100px" (ionInfinite)="getMoreItems($event)" [disabled]="isLoading === true">
    <ion-infinite-scroll-content loadingSpinner="circular" loadingText="Cargando información...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>